/**
 * Générateur — Il écrit un script de déplacement ou de construction
 * géométrique (conditionnelles et/ou boucle « Répéter … fois »).
 * Attendu ID : 246 | Niveau : 3ème | Domaine : Algorithmique (d21, O2 niv. 2)
 *
 * ⚠️ BANQUE 3e (doc muet — option (a) du TODO §5). Plan auto-validé
 * 2026-07-18 : « rectangle » (compléter le script du rectangle : les deux
 * avancées dans la boucle ×2), « escalier » (répéter n marches : longueur
 * totale tracée et avancée horizontale).
 */

import { randomChoice, randInt, makeTexteTrou } from '../../../utils';
import { imgElement, svgScript } from '../../4eme/algorithmique/algo';

const ATTENDU_ID = 246;
const L_RECTANGLE = 'Le script du rectangle';
const L_ESCALIER = 'Le script de l\'escalier';
const opts = (label) => ({ niveau: '3eme', matiere: 'maths', attendu: ATTENDU_ID, label });

// ═════════ « rectangle » ═════════

const genRectangleTrous = () => {
    let L; let l;
    for (let essai = 0; essai < 20; essai++) {
        L = randInt(6, 15) * 10;
        l = randInt(3, 9) * 10;
        if (L !== l) break;
    }
    const phrase = `répéter 2 fois [avancer de {{${L}}} ; tourner ↻ de 90 degrés ; avancer de {{${l}}} ; tourner ↻ de 90 degrés].`;
    const payload = makeTexteTrou(phrase,
        `<p>On veut tracer un RECTANGLE de longueur ${L} pas et de largeur ${l} pas, en commençant par la `
        // « un rectangle = deux fois le motif longueur-quart de tour-… »
        // décrivait le corps de boucle que l'élève doit reconstituer.
        + 'longueur. Le script utilise la boucle « répéter 2 fois ».</p>'
        + '<p><b>Complète le script.</b></p>',
        { ...opts(L_RECTANGLE), mode: 'saisie' });
    payload.elements_additionnels = imgElement(svgScript([
        { t: 'hat', txt: 'quand le drapeau est cliqué' },
        { t: 'repeat', n: 2, body: [
            { t: 'move', txt: 'avancer de …' },
            { t: 'move', txt: 'tourner ↻ de 90 degrés' },
            { t: 'move', txt: 'avancer de …' },
            { t: 'move', txt: 'tourner ↻ de 90 degrés' },
        ] },
    ]));
    payload._meta.params = { L, l };
    return payload;
};

// ═════════ « escalier » ═════════

const genEscalierTrous = () => {
    let n; let a; let totale; let horiz;
    for (let essai = 0; essai < 30; essai++) {
        n = randInt(3, 7);
        a = randInt(2, 6) * 10;
        totale = n * 2 * a;                                 // chaque marche : montée a + avancée a
        horiz = n * a;
        if (totale !== horiz && n !== a) break;
    }
    const phrase = `Longueur totale tracée : {{${totale}}} pas ; avancée horizontale : {{${horiz}}} pas.`;
    const payload = makeTexteTrou(phrase,
        `<p>Script de l'escalier : <code>répéter ${n} fois [monter de ${a} ; tourner à droite ; `
        + `avancer de ${a} ; tourner à gauche]</code>. Chaque tour de boucle trace UNE marche ; `
        + `l'escalier a donc ${n} marches.</p>`
        + '<p><b>Quelle longueur totale le stylo trace-t-il, et de combien de pas le lutin avance-t-il '
        + 'HORIZONTALEMENT en tout ?</b></p>',
        { ...opts(L_ESCALIER), mode: 'saisie' });
    payload._meta.params = { n, a, totale, horiz };
    return payload;
};

const GENERATORS = {
    rectangle_texte_trou_saisie: genRectangleTrous,
    escalier_texte_trou_saisie: genEscalierTrous,
};
const FORMAT_LABELS = { texte_trou_saisie: 'Saisie trous' };
const buildFormats = (prefix) =>
    Object.keys(GENERATORS).filter(k => k.startsWith(`${prefix}_`))
        .map(k => ({ key: k, label: FORMAT_LABELS[k.slice(prefix.length + 1)] || k }));
export const CATEGORIES = [
    { id: 'rectangle', label: L_RECTANGLE, formatsList: buildFormats('rectangle') },
    { id: 'escalier', label: L_ESCALIER, formatsList: buildFormats('escalier') },
];
export const generate = (typeExercice) => {
    let key;
    if (typeExercice && GENERATORS[typeExercice]) key = typeExercice;
    else if (typeExercice) {
        const matching = Object.keys(GENERATORS).filter(k => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(Object.keys(GENERATORS));
    } else key = randomChoice(Object.keys(GENERATORS));
    const payload = GENERATORS[key]();
    payload._meta.generatorKey = key;
    return payload;
};
